import React from 'react'
import Header, { listImage } from '../../components/header/header'
import Layout from '../../core/layout/layout'
import HeaderOptions from '../../components/header-options/header-options'
import { listOfferItem } from '../landing/data'
import OfferItem from '../landing/components/offer-item/offer-item'
import CustomSlider from '../../components/custom-slider/custom-slider'
import Slider from "react-slick";
import SectionTC from '../../components/section-tc/section-tc'
import styled from 'styled-components'
import FormSearchTour from '../landing/components/form-search-tour/form-search-tour'
import { device } from '../../config/theme/breakpoints'
import OfferTicketItem from './offer-ticket-item/offer-ticket-item'
import { listOfferTicketItem } from './data'

const BodyHeaderContainer = styled.div`
  color: white;
  text-align: center;
  width: 100%;
  padding: 80px 0 50px;

  > div span{
    font-size: 12px;
  }

  @media ${device.tablet}{
    padding: 120px 0 50px;
  }
`
const PreTitle = styled.h3`
  font-style: italic;
  margin-bottom: 10px;
  font-weight: lighter;
  text-transform: uppercase;
  margin: 0;
  margin-top: 20px;
`
const Title = styled.h1`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 40px;
  text-transform: uppercase;
  position: relative;
  width: fit-content;
  margin: auto;
  padding-bottom: 5px;
  margin-bottom: 40px;
`
const TitleBar = styled.div`
    width: 30px;
    height: 7px;
    background: ${p => p.theme.palette.secondary.main};
    position: absolute;
    right: 0;
    bottom: 0;
    border-radius: 6px 0 15px 6px;
    transform: skew(-30deg);
`

const FeatureCustomClass = `
    display: inherit;
    background: #FEA500;
`
const ContainerOfferPrice = styled.div`
  background: ${p => p.theme.palette.primary.main};
  position: absolute;
  top: 30%;
  width: 38%;
  border-radius: 0 80px 30px 0;
  display: none;
  justify-content: flex-end;
  align-items: center;

  > div {
    margin-top: 15px;
    margin-bottom: 15px;
    margin-right: 15px;
  }

  > div div {
    width: fit-content;

    > p {
      margin: 0;
      color: ${p => p.theme.palette.secondary.main};
      font-style: italic;
    }

    > h1 {
      margin: 0;
    }
  }

  @media ${device.tablet}{
    display: flex;
  }
`

const OffersDetail: React.FunctionComponent = () => {
  const sliderOfferRef = React.useRef<Slider>(null);

  return (
    <Layout>
        <Header images={listImage}>
          <BodyHeaderContainer>
            <ContainerOfferPrice>
              <div>
                <div><p>Desde</p></div>
                <div><h1>S/ 90</h1></div>
              </div>
            </ContainerOfferPrice>
            <SectionTC>
              <PreTitle>En pasajes en bus a</PreTitle>
              <Title>
                Chiclayo
                <TitleBar />
              </Title>
              <span>Válido en los canales de venta counter a nivel nacional y via call center</span>
            </SectionTC>
          </BodyHeaderContainer>
        </Header>
        <HeaderOptions className={FeatureCustomClass}>
          <SectionTC hidden>
            <FormSearchTour />
          </SectionTC>
        </HeaderOptions>
        <SectionTC>
            {listOfferTicketItem.map(offer => (
                <OfferTicketItem
                    type={offer.type}
                    inclination={offer.inclination}
                    seatingNumber={offer.seatingNumber}
                    price={offer.price}
                    initTime={offer.initTime}
                    arrivalTime={offer.arrivalTime}
                    fromCity={offer.fromCity}
                    toCity={offer.toCity}
                    time={offer.time}
                    listOptions={offer.listOptions}
                />
            ))}
        </SectionTC>
        <CustomSlider
          sliderRef={sliderOfferRef}
          preTitle='Principales destinos'
          title='Y promociones'
          size={listOfferItem.length}
          withIconRight
        >
          {listOfferItem.map(offer => (
            <div key={offer.id}>
              <OfferItem
                  tour={offer.tour}
                  price={offer.price}
                  title={offer.title}
                  subTitle={offer.subTitle}
                  image={offer.image}
                />
            </div>
          ))}
        </CustomSlider>
    </Layout>
  )
}

export default OffersDetail